import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  signInWithEmailAndPassword,
  updateProfile,
  deleteUser,
} from 'firebase/auth';
import { auth } from './config';
import { createUserDocument } from './userService';

const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  return result;
};

export const registerWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const isNewUser = result._tokenResponse?.isNewUser ?? false;

  await createUserDocument(result.user, {
    provider: 'google',
  });

  return { user: result.user, isNewUser };
};

export const removeCurrentAuthUser = async () => {
  if (auth.currentUser) {
    await deleteUser(auth.currentUser);
  }
};

export const registerWithEmail = async (name, email, password) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);

  if (result.user) {
    await updateProfile(result.user, {
      displayName: name,
    });

    await createUserDocument(
      {
        ...result.user,
        displayName: name,
      },
      {
        name,
        provider: 'email',
      }
    );
  }

  return auth.currentUser;
};

export const loginWithEmail = async (email, password) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result.user;
};

export const logoutUser = async () => {
  await signOut(auth);
};